import { useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore, useIsAuthenticated } from '@/stores/auth-store'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const [rehydrated, setRehydrated] = useState(() => useAuthStore.persist.hasHydrated())
  const isAuthenticated = useIsAuthenticated()
  const location = useLocation()

  useEffect(() => {
    if (useAuthStore.persist.hasHydrated()) {
      return
    }
    const unsub = useAuthStore.persist.onFinishHydration(() => setRehydrated(true))
    return () => unsub()
  }, [])

  if (!rehydrated) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <>{children}</>
}